import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=0ac06abc"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports